<template>
  <div>
    <van-nav-bar
      title="主机配货明细"
      left-text="返回"
      right-text="完成"
      left-arrow
      @click-left="onClickLeft"
      @click-right="finishHostAllocation"
      fixed
    />
    <div class="psiConfirmCont">
      <div class="psiDetailCont">
        <div>
          <span>整机简介:</span>{{ hostIntroduce }}
          <br />
          <span>配件数量:</span>{{ materialQuantity }}
          <br />
          <div style="display: flex;">
            <van-field
              v-model="inputBarcode"
              center
              clearable
              label=""
              ref="inputBarcode"
              placeholder="请输入条码"
            >
              <template #button>
                <van-button size="small" type="info" @click="scanBarcode"
                  >确定</van-button
                >
              </template>
            </van-field>
          </div>
          <!--          <div style="width: 100%">-->
          <!--            <input style="width: 100%" type="text" placeholder="请输入条码" v-bind="inputBarcode" @keyup="scanBarcode">-->
          <!--          </div>-->
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          v-if="userId"
          @load="onLoad"
          finished-text="没有更多了"
        >
          <div v-for="item in list" class="card" :key="item.uuid">
            <template>
              <table class="layout">
                <tr>
                  <td><span>商品编码：</span>{{ item.skuCode }}</td>
                  <td width="20%" v-if="item.isUseSerialNumber === '11'">
                    <input
                      type="text"
                      disabled
                      v-model="item.barcode"
                      placeholder="请输入条码"
                    />
                  </td>
                  <td width="20%" v-if="item.isUseSerialNumber === '12'">
                    <input
                      type="text"
                      v-model="item.quantity"
                      placeholder="请输入数量"
                    />
                  </td>
                </tr>
                <tr>
                  <td><span>商品名称：</span>{{ item.skuName }}</td>
                  <td width="20%" v-if="item.isUseSerialNumber === '11'">
                    <input
                      type="text"
                      disabled
                      v-model="item.binId"
                      placeholder="暂无货位码"
                    />
                  </td>
                  <td width="20%" v-if="item.isUseSerialNumber === '12'">
                    <input
                      type="text"
                      v-model="item.binId"
                      placeholder="请输入货位码"
                    />
                  </td>
                </tr>
              </table>
            </template>
          </div>
        </van-list>
      </div>
      <div class="recordBox">
        <div
          style="display: flex;justify-content: space-between;align-items: center;"
        >
          <div
            style="flex: 1;background: #1989fa;display: flex;align-items: center;color:white;height: 30px;padding: 0 10px;border-radius: 2px;font-size: 12px;"
          >
            <span>已配数量:</span>
            {{ quantity }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  NavBar,
  Field,
  Button,
  List,
  PullRefresh,
  Toast,
} from "vant";
import electronicAllocationService from "../../service/electronicAllocationService";

export default {
  data() {
    return {
      selected: 0,
      type: "",
      quantity: 0,
      list: [],
      loading: false,
      showStartAllocation: false,
      showEndAllocation: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      fields: [],
      dictNames: "",
      inputBarcode: "",
      inputBarcodeSkuId: "",
      hostIntroduce: "",
      materialQuantity: 0,
      showPosition: true,
    };
  },
  mounted: async function() {
    this.type = this.$route.query.type;
    let that = this;
    document.onkeydown = async function(event) {
      if (event.keyCode == 13) {
        that.scanBarcode();
      }
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    userName() {
      return this.$store.getters.getUserName;
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async scanBarcode() {
      if (this.inputBarcode == "" || this.inputBarcode == undefined) {
        Toast.fail("条码不能为空");
        return;
      }
      let a = false;
      for (let i = 0; i < this.list.length; i++) {
        const element = this.list[i];
        if (this.inputBarcode == element.barcode) {
          a = true;
        }
      }

      if (a) {
        Toast.fail("当前列表条码重复,请重新填写!");
        this.inputBarcode = "";
        this.inputBarcodeSkuId = "";
        this.$refs.inputBarcode.focus();
      } else {
        let resp = await electronicAllocationService.selectBarcodeAvailable(
          this.inputBarcode
        );
        if (resp.data.Status == "1" && resp.data.Data == "条码可用") {
          // 查询条码对应商品id
          let resp3 = await electronicAllocationService.getSkuIdByBarcode(
            this.inputBarcode
          );

          if (resp3.data.Status == "1" && resp3.data.Data) {
            this.inputBarcodeSkuId = resp3.data.Data;
          }
          let resp2 = await electronicAllocationService.getBinInfoByBarcode(
            this.inputBarcode
          );
          if (resp2.data.Status == "1" && resp2.data.Data) {
            for (let i = 0; i < this.list.length; i++) {
              const element = this.list[i];
              if (
                element.barcode == "" &&
                element.skuId == this.inputBarcodeSkuId
              ) {
                element.barcode = this.inputBarcode;
                element.binName = resp2.data.Data[0].binName;
                element.binId = resp2.data.Data[0].binName;
                this.quantity++;
                break;
              }
            }
            this.inputBarcode = "";
            this.inputBarcodeSkuId = "";
            this.$refs.inputBarcode.focus();
          } else {
            Toast.fail("没有查询到条码，或条码未入库");
            this.inputBarcode = "";
            this.inputBarcodeSkuId = "";
            this.$refs.inputBarcode.focus();
          }
        } else {
          Toast.fail(resp.data.Data);
          this.inputBarcode = "";
          this.inputBarcodeSkuId = "";
          this.$refs.inputBarcode.focus();
        }
      }
    },
    finishHostAllocation() {
      let data = this.list;
      let flag = true;
      // eslint-disable-next-line no-unused-vars
      let flag1 = true;
      let distributedQuantity = 0;
      for (let i = 0; i < data.length; i++) {
        if (
          !(
            ((data[i].barcode != undefined && data[i].barcode != "") ||
              (data[i].quantity != undefined && data[i].quantity != "")) &&
            data[i].binId != undefined &&
            data[i].binId != ""
          )
        ) {
          flag = false;
          continue;
        } else {
          distributedQuantity++;
        }
      }
      electronicAllocationService.saveDistributedQuantity(
        distributedQuantity,
        this.$route.params.detailId
      );
      if (flag) {
        let resp = electronicAllocationService.saveHostDetail(
          this.list,
          this.$route.params.detailId
        );
        if (resp.data.Status == "1") {
          Toast.success("保存成功");
          this.$router.go(-1);
        } else {
          Toast.fail(resp.data.Message);
        }
      } else {
        Toast.fail("主机的配件条码，全部填写完整才可以保存");
      }
    },
    async onLoad() {
      this.pageIndex++;
      let hostResult = await electronicAllocationService.getAllocationOfCargoHostById(
        this.$route.params.detailId
      );
      if (hostResult.data.Status == "1" && hostResult.data.Data.length > 0) {
        this.hostIntroduce = hostResult.data.Data[0].hostIntroduce;
        this.materialQuantity = hostResult.data.Data[0].partsQuantity;
      }
      let resp = await electronicAllocationService.getHostDetailById(
        this.pageIndex,
        this.$route.params.detailId
      );
      let hostDetailList = [];
      if (resp.data.Status == "1" && resp.data.Data.length > 0) {
        let data = resp.data.Data;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          for (let j = 0; j < item.barcodeDetail.length; j++) {
            hostDetailList.push({
              uuid: item.barcodeDetail[j].uuid,
              hostDetailId: item.barcodeDetail[j].uuid,
              skuId: item.barcodeDetail[j].skuId,
              skuName: item.barcodeDetail[j].skuName,
              barcode: item.barcodeDetail[j].barcode,
              creatorId: item.barcodeDetail[j].creatorId,
              creatorName: item.barcodeDetail[j].creatorName,
              binId: item.barcodeDetail[j].binId,
              quantity: item.barcodeDetail[j].quantity,
              binName: item.barcodeDetail[j].binId,
              isUseSerialNumber: item.isUseSerialNumber,
              skuCode: item.barcodeDetail[j].skuCode,
            });
          }
          // 未配条码的给空数据
          for (
            let j = item.barcodeDetail.length;
            j < item.shouldDistributeQuantity;
            j++
          ) {
            hostDetailList.push({
              uuid: "detail" + i + j,
              hostDetailId: item.uuid,
              skuId: item.skuId,
              skuName: item.skuName,
              barcode: "",
              creatorId: this.userId,
              quantity: "",
              creatorName: this.userName,
              isUseSerialNumber: item.isUseSerialNumber,
              binId: "",
              binName: "",
              skuCode: item.skuCode,
            });
          }
        }
      }
      // let resp2 = await electronicAllocationService.getOrderInfoByOrderId(this.pageIndex, this.$route.params.allocationDataId);
      // if (resp2.data.Data[0].status == '1'){
      //   this.showStartAllocation = false;
      //   this.showEndAllocation = true;
      // }else if (resp2.data.Data[0].status == '2'){
      //   this.showStartAllocation = false;
      //   this.showEndAllocation = false;
      // }else {
      //   this.showStartAllocation = true;
      //   this.showEndAllocation = true;
      // }
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...hostDetailList];
      this.finished = true;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
  },
};
</script>

<style scoped>
.psiConfirmCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}
.btnBox {
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
}
.psiDetailCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}
.hostStatus {
  background-color: #e2e3e2;
  text-align: center;
}
</style>
